import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMic = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16.88,
	height: 27,
	viewBox: "0 0 16.88 27",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.88,11V13.5a8.43,8.43,0,0,1-7.6,8.38v3.43h3.38a.85.85,0,0,1,0,1.69H4.22a.85.85,0,0,1,0-1.69H7.59V21.87A8.63,8.63,0,0,1,0,13.2V11a.85.85,0,1,1,1.69,0v2.29a6.92,6.92,0,0,0,6.28,7,6.77,6.77,0,0,0,7.22-6.74V11a.85.85,0,1,1,1.69,0ZM3.38,13.5V5.06a5.06,5.06,0,0,1,10.12,0V13.5a5.06,5.06,0,0,1-10.12,0Zm1.68-.15a3.48,3.48,0,0,0,3,3.51,3.38,3.38,0,0,0,3.71-3.36H9.28a.85.85,0,0,1,0-1.69h2.53V10.12H9.28a.84.84,0,0,1,0-1.68h2.53V6.75H9.28a.85.85,0,0,1,0-1.69h2.53A3.38,3.38,0,0,0,8.09,1.7a3.49,3.49,0,0,0-3,3.52Z",
		fill: "#5b1954"
	})]
});
const ForwardRef = forwardRef(SvgMic);
export default ForwardRef;
